import MainLayout from '@/layouts/MainLayout.vue';
import { PageName } from '@/common/constants';
import { RouteRecordRaw } from 'vue-router';
import CalendarPage from './pages/CalendarPage.vue';
import CalendarDetailPage from './pages/CalendarDetailPage.vue';
import { ProjectSecurityPermissions } from '../3D-viewer-profile/constants';

const calendarRouter: Array<RouteRecordRaw> = [
    {
        path: '/project',
        component: MainLayout,
        children: [
            {
                path: 'calendar',
                name: PageName.CALENDAR_PAGE,
                component: CalendarPage,
                meta: {
                    requiresAuth: true,
                    isViewProject: true,
                    breadcrumb: [
                        {
                            text: 'calendar.breadcrumb',
                            link: '/project/calendar',
                        },
                    ],
                    requiredPermissions: [
                        ProjectSecurityPermissions.GENERAL_ACCESS_TO_PROJECT,
                    ],
                },
            },
            {
                path: 'calendar/:calendarId',
                name: PageName.CALENDAR_CONFIG_PAGE,
                component: CalendarDetailPage,
                props: true,
                meta: {
                    requiresAuth: true,
                    isViewProject: true,
                    breadcrumb: [
                        {
                            text: 'calendar.breadcrumb',
                            link: '/project/calendar',
                        },
                    ],
                    requiredPermissions: [
                        ProjectSecurityPermissions.GENERAL_ACCESS_TO_PROJECT,
                    ],
                },
            },
        ],
    },
];

export default calendarRouter;
